module.exports = __webpack_public_path__ + "img/07-man.ac0767ca.svg";